import MapPopup from './mapPopup';

export default MapPopup;
